import { defineStore } from "pinia";
import { ref } from "vue";

export const useProcedureSummingStore = defineStore('procedureSumming', () => {
    const showDecisionGrid = ref(false);

    function setShowDecisionGrid(value) {
        showDecisionGrid.value = value;
    }

    return {
        showDecisionGrid,
        setShowDecisionGrid
    }
});
